export class VideoPlayback {

    private _state: boolean = false;
    private btn: HTMLElement | null;
    private video: HTMLVideoElement | null;

    constructor(button: HTMLElement, video: HTMLVideoElement) {
        this.btn = button;
        this.video = video;

        this.btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.state = true;
        });

        this.video.addEventListener('pause', () => {
            if (!this.video.seeking) {
                this.state = false;
            }
        });

        this.video.addEventListener('ended', () => {
            this.state = false;
        });
    }

    public set state(value: boolean) {
        this._state = value;
        this.onStateChange(value);
    }

    public get state(): boolean {
        return this._state;
    }

    private onStateChange(value: boolean) {
        value === true ? this.startPlayback() : this.stopPlayback();
    }

    public startPlayback() {
        this.video.play();
        this.video.setAttribute('controls', '');
        this.btn.classList.add('video-box-btn--off');
    }

    public stopPlayback() {
        this.video.removeAttribute('controls');
        this.btn.classList.remove('video-box-btn--off');
    }
}